import { match, React } from '../../../lib';
export const ToolRendererContext = React.createContext({});
export const hasCustomRenderer = (widgetCode, ctx) => (ctx.renderers?.[widgetCode] ?? defaultRenderers[widgetCode]) != null;
export const renderToolOutput = (toolCall, ctx) => {
    const tool = toolCall.tool;
    const widgetCode = 'widget' in tool ? tool.widget : null;
    if (!widgetCode) {
        return null;
    }
    const renderer = ctx.renderers?.[widgetCode] ?? defaultRenderers[widgetCode];
    if (!renderer) {
        return null;
    }
    const data = match(toolCall)
        .with({ kind: 'presentation' }, tc => tc.tool.input)
        .with({ kind: 'change' }, tc => tc.tool.input)
        .otherwise(() => null);
    if (data == null || typeof data === 'string') {
        return null;
    }
    return renderer(data, ctx);
};
const defaultRenderers = {};
//# sourceMappingURL=tool-renderers.js.map